
import BaseImage from '@/common/components/BaseImage.vue'
import PrintTag from '@/common/components/PrintTag.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import Vue from 'vue'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'

export default Vue.extend({
  components: {
    BaseImage,
    PrintTag,
    FavoriteBtn
  },
  props: {
    alt: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    itemUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      required: false,
      default: undefined
    },
    minPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    minQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    maxQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    minCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    printTag: {
      type: String,
      default: null
    },
    estimateItemId: {
      type: String,
      required: false,
      default: null
    }
  },
  data(): {
    productEstimatedItemId: number | null
  } {
    return {
      productEstimatedItemId: null
    }
  },
  computed: {
    currentProductEstimatedItemId(): number | null {
      return this.productEstimatedItemId
    },
    currentProductId(): string {
      return this.productId
    },
    hasCampaignPrice(): boolean {
      return !!this.minCampaignPrice
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  }
})
